import { SELECIONAR_USUARIO } from '../types';

export default function selecionarUsuario (data) {
  return {
    type: SELECIONAR_USUARIO,
    payload: data
  }
}
